import { render, staticRenderFns } from "./floatbtn.vue?vue&type=template&id=7fb108a3&scoped=true&lang=true&"
import script from "./floatbtn.vue?vue&type=script&lang=js&"
export * from "./floatbtn.vue?vue&type=script&lang=js&"
import style0 from "./floatbtn.vue?vue&type=style&index=0&id=7fb108a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb108a3",
  null
  
)

export default component.exports